import { useQuery } from "@tanstack/react-query";
import { trainerAvailabilityApi } from "api/trainers/trainerAvailabilityApi";
import { QUERIES_KEYS } from "queries";

export const useTrainerAvailabilityRequests = (trainerId: number) => {
  return useQuery({
    queryKey: QUERIES_KEYS.TRAINER_AVAILABILITY_REQUESTS(trainerId),
    queryFn: () => trainerAvailabilityApi.fetchAvailabilityRequests(trainerId),
    select: (res) => res.data,
  });
};
